import { QueryString } from 'core/utils/queryString/queryString';
import { SearchQueryKey } from 'core-framework/constant/SearchQueryKey';
import { DefaultRequestProps } from 'store/api/ApiConstants';

export const getPageNumberFromQueryParams = (locationSearch: string): number => {
    const defaultPage = DefaultRequestProps.search.pagination.number;
    if (!locationSearch) return defaultPage;

    const query = new QueryString(locationSearch);
    const pageStr = query.get(SearchQueryKey.PageNumber) || '';

    if (pageStr) {
        const page = Number(pageStr);
        return Number.isNaN(page) || page <= 0 ? defaultPage : page;
    }
    return defaultPage;
};

export const getPaginationQueryString = (locationSearch: string, page: number, size: number): string => {
    const query = new QueryString(locationSearch);
    // Restrict boundary value page numbers input by users
    if (!page || page <= 1) {
        query.delete(SearchQueryKey.PageNumber);
    } else if (page > 1) {
        query.set(SearchQueryKey.PageNumber, String(page));
    }
    return query.toString();
};
